<section class="tracking-number">
	<div class="tracking-number__content">
		<button
			class="tracking-number__close-btn"
			(click)="onCloseTrackingNumber()">
			<i class="bi bi-x-circle"></i>
		</button>
		<h2 class="tracking-number__title">¡Tu tarjeta está en camino!</h2>
		<p *ngIf="address" class="tracking-number__address">
			<span>Hemos enviado tu tarjeta a tu domicilio</span><br />
			{{ address.street }} {{ address.exteriorNumber }}
			{{ address.interiorNumber }},<br />
			{{ address.colony }} <br />
		</p>
		<div class="tracking-number__code">
			<p>
				Puedes rasearlo a través del portal de <span>Estafeta</span> con el
				número de guía:
			</p>
			<span>{{ trackingNumber }}</span>
		</div>
	</div>
</section>
